import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { ContractService } from 'src/app/shared/store/contract/contract.service';
import { CarInsuranceContractModel } from 'src/app/shared/store/contract/types';

@Component({
    selector: 'app-contract-details-driver',
    templateUrl: './contract-details-driver.component.html',
    styleUrls: ['./contract-details-driver.component.scss'],
    standalone: false
})
export class ContractDetailsDriverComponent {
  constructor(private readonly contractService: ContractService) {}

  carDetail$: Observable<CarInsuranceContractModel>;

  ngOnInit(): void {
    this.carDetail$ = this.contractService.getCarDetail.value$;
  }
}
